<template>
  <div v-on-clickaway="closeDropdownLabel" class="label-wrap">
    <!-- <add-label @add="toggleLabels" /> -->
    <!-- <woot-label
      v-for="label in savedLabels"
      :key="label.id"
      :title="label.title"
      :description="label.description"
      :color="label.color"
      variant="smooth"
      @click="removeItem"
    /> -->
    <!-- v-for="(label, index) in displayedLabels" -->
    <woot-label
      v-for="label in displayedLabels"
      :key="label.id"
      :title="label.title.length > 15 ? label.title.slice(0, 15) + '...' : label.title"
      v-tooltip="label.title.length > 15 ? label.title : ''"
      :color="label.color"
      :automation="label.automation"
      :contact-automation="label.contact_automation"
      :exclude-from-default-views="label.exclude_from_default_views"
      variant="smooth"
      @click="removeItem"
    />
       <!-- If there are more than 2 labels, show the +X label -->
    <woot-label
      v-if="extraLabelsCount > 0"
      :key="'extra-labels'"
      :title="'+' + extraLabelsCount"
    />

    <div class="dropdown-wrap">
      <div
        :class="{ 'dropdown-pane--open': showSearchDropdownLabel }"
        class="dropdown-pane"
        style="min-width: 250px;"
      >
        <label-dropdown
          v-if="showSearchDropdownLabel"
          :account-labels="allLabels"
          :selected-labels="selectedLabels"
          :allow-creation="isAdmin"
          @add="addItem"
          @remove="removeItem"
        />
      </div>
    </div>
  </div>
</template>

<script>
import AddLabel from 'shared/components/ui/dropdown/AddLabel';
import eventListenerMixins from 'shared/mixins/eventListenerMixins';
import LabelDropdown from 'shared/components/ui/label/LabelDropdown';
import { mixin as clickaway } from 'vue-clickaway';
import adminMixin from 'dashboard/mixins/isAdmin';
import {
  buildHotKeys,
  isEscape,
  isActiveElementTypeable,
} from 'shared/helpers/KeyboardHelpers';

export default {
  components: {
    AddLabel,
    LabelDropdown,
  },

  mixins: [clickaway, adminMixin, eventListenerMixins],

  props: {
    allLabels: {
      type: Array,
      default: () => [],
    },
    savedLabels: {
      type: Array,
      default: () => [],
    },
    popup: {
    type: Boolean,
    default: false,
  },
  selectedContactId: {
    type: Number,
    default: null,
  }
  },

  data() {
    return {
      showSearchDropdownLabel: false,
    };
  },

  computed: {
    selectedLabels() {
      return this.savedLabels.map(label => label.title);
    },
    displayedLabels() {
      return this.savedLabels.slice(0, 2);
    },
    // Count how many extra labels exist beyond the first two
    extraLabelsCount() {
      return this.savedLabels.length - 2 > 0 ? this.savedLabels.length - 2 : 0;
    },
    shouldShowAddLabel() {
    const isPipelineRoute = this.$route.path.includes('/pipelines');
    console.log("My Contact id",this.contactId,this.selectedContactId);
    console.log("HI",this.popup,this.contactId === this.selectedContactId,!isPipelineRoute);
    return (this.popup&&this.contactId === this.selectedContactId) || !isPipelineRoute;
  }
  },

  methods: {
    addItem(label) {
      this.$emit('add', label);
    },

    removeItem(label) {
      this.$emit('remove', label);
    },

    toggleLabels() {
      this.showSearchDropdownLabel = !this.showSearchDropdownLabel;
    },

    closeDropdownLabel() {
      this.showSearchDropdownLabel = false;
    },

    handleKeyEvents(e) {
      const keyPattern = buildHotKeys(e);

      if (keyPattern === 'l' && !isActiveElementTypeable(e)) {
        this.toggleLabels();
        e.preventDefault();
      } else if (isEscape(e) && this.showSearchDropdownLabel) {
        this.closeDropdownLabel();
        e.preventDefault();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.title-icon {
  margin-right: var(--space-smaller);
}

.label-wrap {
  position: relative;
  line-height: var(--space-medium);

  .dropdown-wrap {
    display: flex;
    position: absolute;
    margin-right: var(--space-medium);
    top: var(--space-medium);
    width: 100%;
    left: -1px;

    .dropdown-pane {
      width: 100%;
      box-sizing: border-box;
    }
  }
}
</style>
